<template>
  <div class="builderPost">
    <div v-if="LoadingSkeleton" class="detailsContainer">
      <div class="containerList">
        <div class="listThumb">
          <div class="thumbPic">
            <Skeletor
              style="width: 100%; height: 100%; background: rgb(163, 219, 213)"
            />
          </div>
          <div class="thumbContent">
            <div class="contentHeader">
              <div class="headerContent">
                <div class="contentPic">
                  <Skeletor
                    style="
                      width: 42px;
                      height: 42px;
                      border-radius: 50%;
                      background: rgb(163, 219, 213);
                    "
                  />
                </div>
                <div class="contentInfo">
                  <Skeletor
                    style="
                      width: 124px;
                      height: 28px;
                      border-radius: 9999px;
                      background: rgb(163, 219, 213);
                    "
                  />
                </div>
              </div>
            </div>
            <div ref="contentMain" class="contentMain">
              <div class="mianHeader">
                <div class="headerTitle">
                  <Skeletor
                    style="
                      width: 60%;
                      height: 28px;
                      border-radius: 9999px;
                      background: rgb(163, 219, 213);
                      margin-bottom: 12px;
                    "
                  />
                </div>
                <div class="headerContent">
                  <Skeletor
                    v-for="i in 8"
                    :key="i"
                    style="
                      width: 100%;
                      height: 16px;
                      border-radius: 9999px;
                      background: rgb(163, 219, 213);
                      margin-bottom: 4px;
                    "
                  />
                </div>
              </div>
              <div class="mainOptions">
                <div class="optionsList">
                  <Skeletor
                    v-for="i in 3"
                    :key="i"
                    style="
                      width: 40px;
                      height: 40px;
                      border-radius: 4px;
                      background: rgb(163, 219, 213);
                      margin-bottom: 12px;
                      margin-left: 12px;
                    "
                  />
                </div>
              </div>
              <!-- <div
                v-if="postCommentsList.length > 0 && !commentsLoademoreLoading"
                class="mainList"
              >
                <div
                  v-for="(CommentUserLists, i) in postCommentsList"
                  :key="i"
                  class="listThumb"
                >
                  <div class="listThumbWrapper">
                    <div class="thumbPic">
                      <img
                        :src="CommentUserLists.avatar"
                        :alt="CommentUserLists.name"
                      />
                    </div>
                    <div class="thumbContent">
                      <div class="contentDesc">
                        <span class="userTitle">{{
                          CommentUserLists.name
                        }}</span>
                        {{ CommentUserLists.description }}
                      </div>
                      <div class="contentDetails">
                        <div class="detailsTime">
                          {{ CommentUserLists.date }}
                        </div>
                        <div
                          class="detailsReply"
                          @click="post_replay_focuse(CommentUserLists.id)"
                        >
                          پاسخ دادن
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="thumbReplyList">
                    <div
                      v-for="(replaies, j) in CommentUserLists.replay"
                      :key="j"
                      class="listThumb"
                    >
                      <div class="listThumbWrapper">
                        <div class="thumbPic">
                          <img :src="replaies.avatar" :alt="replaies.name" />
                        </div>
                        <div class="thumbContent">
                          <div class="contentDesc">
                            <span class="userTitle">{{ replaies.name }}</span>
                            {{ replaies.description }}
                          </div>
                          <div class="contentDetails">
                            <div class="detailsTime">
                              {{ replaies.date }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="mobileNocomments"
                v-if="postCommentsList.length == 0 && !commentsLoademoreLoading"
              >
                نظری ثبت نشده است
              </div>
              <div class="loadeMoreLoader" v-if="commentsLoademoreLoading">
                <span class="custom-loader"></span>
              </div> -->
            </div>
            <!-- <div class="contentFooter">
              <div class="footerFooter">
                <div v-if="$store.getters.auth.loggedIn" class="footerGroup">
                  <div
                    v-if="!post_comment_btn_loading"
                    @click="postCommentsSaveHandler(0, 'mob')"
                    class="groupButton"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                    >
                      <path
                        d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"
                      />
                    </svg>
                  </div>
                  <div v-if="post_comment_btn_loading" class="groupButton">
                    <span class="postCommentloader"></span>
                  </div>
                  <input
                    type="text"
                    class="groupInput"
                    :class="{ reply: postParent_id != 0 }"
                    placeholder="کامنت خود را بنویسید"
                    v-model="postNewComment"
                  />
                  <div
                    v-if="postParent_id !== 0"
                    class="cancleReply"
                    @click="replay_blur"
                  >
                    انصراف
                  </div>
                </div>
                <div
                  v-if="!$store.getters.auth.loggedIn"
                  class="loginAlerContainer"
                >
                  <div class="loginAler">
                    برای ثبت نظر وارد حساب کاربری شوید
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="!LoadingSkeleton" class="detailsContainer">
      <div class="containerList">
        <div class="listThumb">
          <div class="thumbPic">
            <Swiper
              ref="postSwiper"
              :slides-per-view="1"
              :space-between="16"
              :modules="module"
              :pagination="{
                dynamicBullets: true,
              }"
              :navigation="true"
              @swiper="onSwiperInitialized"
            >
              <SwiperSlide
                v-for="(v, i) in post_datail?.photo_galleries_mobile"
                :key="i"
              >
                <img :src="v.url" alt="" /> </SwiperSlide
              >
              <SwiperSlide v-show="post_datail && post_datail.lat && post_datail.lng">
                <div id="map" class="map"></div>
              </SwiperSlide>
          </Swiper>
          </div>
          <div class="thumbContent">
            <div class="contentHeader">
              <div @click="showProfileHandler" class="headerContent">
                <div class="contentPic">
                  <img :src="info_list?.avatar" alt="" />
                </div>
                <div class="contentInfo">{{ info_list?.nickname }}</div>
              </div>
              <div class="headerOptions">
                <div
                  v-if="
                    ($store.state.auth.uid == null ||
                      $store.state.auth.uid != info_list.uid) &&
                    info_list.is_follow == 1
                  "
                  class="optionFollow"
                  @click="follow(info_list.uid)"
                >
                  دنبال کردن
                </div>
                <div
                  class="optionUnFollow"
                  v-if="
                    ($store.state.auth.uid == null ||
                      $store.state.auth.uid != info_list.uid) &&
                    info_list.is_follow == 2
                  "
                  @click="follow(info_list.uid)"
                >
                  لغو دنبال کردن
                </div>
                <div
                  v-if="
                    $store.state.auth.loggedIn &&
                    $store.state.auth.uid == info_list.uid
                  "
                  @click="editPostHandler(post_datail?.id)"
                  class="optionEditBtn"
                >
                  <i class="fas fa-edit"></i>
                </div>
                <div
                  v-if="
                    $store.state.auth.loggedIn &&
                    $store.state.auth.uid == info_list.uid
                  "
                  @click="del_post(post_datail?.id)"
                  class="optionDelete"
                >
                  <i class="fas fa-trash"></i>
                </div>
              </div>
            </div>
            <div ref="contentMain" class="contentMain">
              <div class="mianHeader">
                <div class="headerTitle">
                  {{ post_datail?.content }}
                </div>
                <div class="headerContent" v-html="post_datail?.details"></div>
              </div>
              <div class="mainOptions">
                <div class="optionsList">
                  <div
                    @click="save_like(post_datail?.id)"
                    class="optionThumb"
                    :class="{ liked: post_datail?.is_like == 2 }"
                  >
                    <svg
                      v-if="post_datail?.is_like == 1"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                      />
                    </svg>
                    <svg
                      v-if="post_datail?.is_like == 2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="size-6"
                    >
                      <path
                        d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
                      />
                    </svg>

                    <div class="thumbNum">
                      {{ post_datail?.likes }}
                    </div>
                  </div>
                  <div class="optionThumb">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
                      />
                    </svg>
                    <div class="thumbNum">
                      {{ post_datail?.comments_count }}
                    </div>
                  </div>
                  <div
                    @click="shareContent(post_datail.id)"
                    class="optionThumb"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                      />
                    </svg>
                  </div>
                </div>
                <!-- <div
                    class="optionsList"
                    @click="save_favorit(post_list[postIndex]?.id)"
                  >
                    <div class="optionThumb">
                      <svg
                        v-if="post_list[postIndex]?.is_favorite == 1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
                        />
                      </svg>
                      <svg
                        v-if="post_list[postIndex]?.is_favorite == 2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="size-6"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div> -->
              </div>
              <div
                v-if="postCommentsList.length > 0 && !commentsLoademoreLoading"
                class="mainList"
              >
                <div
                  v-for="(CommentUserLists, i) in postCommentsList"
                  :key="i"
                  class="listThumb"
                >
                  <div class="listThumbWrapper">
                    <div class="thumbPic">
                      <img
                        :src="CommentUserLists.avatar"
                        :alt="CommentUserLists.name"
                      />
                    </div>
                    <div class="thumbContent">
                      <div class="contentDesc">
                        <span class="userTitle">{{
                          CommentUserLists.name
                        }}</span>
                        {{ CommentUserLists.description }}
                      </div>
                      <div class="contentDetails">
                        <div class="detailsTime">
                          {{ CommentUserLists.date }}
                        </div>
                        <div
                          class="detailsReply"
                          @click="post_replay_focuse(CommentUserLists.id)"
                        >
                          پاسخ دادن
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="thumbReplyList">
                    <div
                      v-for="(replaies, j) in CommentUserLists.replay"
                      :key="j"
                      class="listThumb"
                    >
                      <div class="listThumbWrapper">
                        <div class="thumbPic">
                          <img :src="replaies.avatar" :alt="replaies.name" />
                        </div>
                        <div class="thumbContent">
                          <div class="contentDesc">
                            <span class="userTitle">{{ replaies.name }}</span>
                            {{ replaies.description }}
                          </div>
                          <div class="contentDetails">
                            <div class="detailsTime">
                              {{ replaies.date }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="mobileNocomments"
                v-if="postCommentsList.length == 0 && !commentsLoademoreLoading"
              >
                نظری ثبت نشده است
              </div>
              <div class="loadeMoreLoader" v-if="commentsLoademoreLoading">
                <span class="custom-loader"></span>
              </div>
            </div>
            <div class="contentFooter">
              <div class="footerFooter">
                <div v-if="$store.getters.auth.loggedIn" class="footerGroup">
                  <div
                    v-if="!post_comment_btn_loading"
                    @click="postCommentsSaveHandler(0, 'mob')"
                    class="groupButton"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 640"
                    >
                      <path
                        d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"
                      />
                    </svg>
                  </div>
                  <div v-if="post_comment_btn_loading" class="groupButton">
                    <span class="postCommentloader"></span>
                  </div>
                  <input
                    type="text"
                    class="groupInput"
                    id="newComment_mob"
                    :class="{ reply: postParent_id != 0 }"
                    placeholder="کامنت خود را بنویسید"
                    v-model="postNewComment"
                  />
                  <div
                    v-if="postParent_id !== 0"
                    class="cancleReply"
                    @click="replay_blur"
                  >
                    انصراف
                  </div>
                </div>
                <div
                  v-if="!$store.getters.auth.loggedIn"
                  class="loginAlerContainer"
                >
                  <div class="loginAler">
                    برای ثبت نظر وارد حساب کاربری شوید
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoginUser @close="ShowLoginBoxes = false" v-if="ShowLoginBoxes" />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";
import { toast } from "vue3-toastify";
import LoginUser from "./LoginUser.vue";
import { Skeletor } from "vue-skeletor";
import { Share } from "@capacitor/share";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "destopPostBuilder",
  components: {
    Swiper,
    SwiperSlide,
    LoginUser,
    Skeletor,
  },
  data() {
    return {
      module: [Navigation, Pagination],
      info_list: [],
      post_datail: [],
      mode: "user",
      myprofile: false,
      loadmore: true,
      loadmore_loading: false,
      page: 1,
      isLoading: false,
      imageSrc: null,
      fillter: {
        main_category: "all",
        category: "all",
        bed: -1,
        view_mode: "list",
        user_id: 0,
        m_id: 0,
        per_page: "get",
        post_type: "portfolio",
      },
      total: 0,
      Commentpage: 1,
      commentsTotal: 0,
      postCommentsList: [],
      commentsLoadeMore: true,
      commentsLoading: false,
      commentsLoademoreLoading: false,
      postComment_btn_replay_loading: [],
      postParent_id: 0,
      postNewComment: "",
      post_comment_replay: [],
      post_comment_btn_loading: false,
      postreplyComment: -1,
      ShowLoginBoxes: false,
      loadingFollow: false,
      LoadingSkeleton: false,
      map: null,
      reloadKey: 0,
      markersLayer: null,
      markerOne: null,
      loadMoreTrigger: null,
      center: { latitude: 36.5663854, longitude: 52.6707147 },
      markerPosition: { longitude: 0, latitude: 0 },
      houseIcon: L.divIcon({
        html: `
          <div style="position: relative;">
            <div style="
              position: absolute;
              width: 70px;
              height: 70px;
              background: rgba(0, 0, 0, 0.2);
              border-radius: 50%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "></div>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="67" height="67" viewBox="0 0 67 67">
                <defs>
                    <filter id="cxwfhygxxa" width="211.1%" height="211.1%" x="-55.6%" y="-55.6%" filterUnits="objectBoundingBox">
                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5"/>
                        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.461511145 0"/>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                    <path id="m1l7efvoab" d="M15.317 5.098L8.435.183c-.341-.244-.8-.244-1.142 0L.412 5.098c-.442.316-.544.93-.229 1.371.315.443.93.544 1.371.23l.412-.295v8.341c0 .543.44.983.983.983h9.83c.544 0 .983-.44.983-.983v-8.34c.343.244.587.476.982.476.308 0 .61-.143.801-.412.316-.441.213-1.055-.228-1.371zm-3.52 8.664H9.83v-2.949c0-1.086-.88-1.966-1.966-1.966-1.086 0-1.966.88-1.966 1.966v2.95H3.932V5L7.864 2.19 11.796 5v8.762z"/>
                </defs>
                <g fill="none" fill-rule="evenodd" filter="url(#cxwfhygxxa)" transform="translate(15.127 15.127)">
                    <rect width="32.887" height="32.887" x="1.43" y="1.43" fill="#213743" stroke="#192B37" stroke-width="2.86" rx="8.579"/>
                    <g transform="translate(10.009 10.009)">
                        <mask id="wd87vlifuc" fill="#fff">
                            <use xlink:href="#m1l7efvoab"/>
                        </mask>
                        <use fill="#000" fill-rule="nonzero" xlink:href="#m1l7efvoab"/>
                        <g fill="#FFF" mask="url(#wd87vlifuc)">
                            <path d="M0 0H15.728V15.728H0z"/>
                        </g>
                    </g>
                </g>
            </svg>
          </div>`,
        className: "house-marker",
        iconSize: [70, 70],
        iconAnchor: [35, 35],
      }),
    };
  },
  methods: {
    async initializeMap() {
      try {
        if (!this.map) {
          this.map = L.map("map", {
            dragging: true,
            touchZoom: true,
            scrollWheelZoom: true,
            doubleClickZoom: true,
            boxZoom: true,
            keyboard: true,
            zoomControl: true,
          });

          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 20,
            minZoom: 5,
            attribution: "© OpenStreetMap Abarline",
          }).addTo(this.map);
        }

        this.updateMapLocation();
      } catch (error) {
        console.error("Map initialization error:", error);
      }
    },
    updateMapLocation() {
      const lat = this.post_datail?.lat;
      const lng = this.post_datail?.lng;

      if (!lat || !lng) return;

      this.map.setView([lat, lng], 16);

      if (this.markerOne) {
        this.map.removeLayer(this.markerOne);
      }

      this.markerOne = L.marker([lat, lng], { icon: this.houseIcon }).addTo(
        this.map
      );

      this.map.invalidateSize();
    },
    getmounted(map) {
      this.map = map;
      this.initializeMap(map);
    },
    user_info_func(param) {
      let self = this;
      this.LoadingSkeleton = true;
      self.mode = "user";
      const uid = this.$route.params.userId;
      const routeid = this.$route.params.id;
      var user_id = 0;
      var list_type = "public";

      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
        if (user_id == uid) {
          list_type = "own_profile";
          this.myprofile = true;
        }
      }

      this.loadmore = true;
      this.loadmore_loading = true;
      this.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.post_datail = null;
        this.page = 1;
      }

      this.helperGet(
        "user-infos",
        "uid=" +
          uid +
          "&user_id=" +
          user_id +
          "&page=" +
          this.page +
          "&list_type=" +
          list_type +
          "&post_type=" +
          "portfolio"
      ).then((res) => {
        self.info_list = res.data;
        res.data.has_avatar ? (this.imageSrc = res.data.avatar) : "";

        self.post_datail = res.data.posts.list.find((p) => p.id == routeid);

        this.$nextTick(() => {
          this.getmounted()
        })
        if (res.data.posts.total_page == self.page) {
          this.loadmore = false;
        }

        this.isLoading = false;
        this.loadmore_loading = false;
        this.LoadingSkeleton = false;
      });
    },
    showProfileHandler() {
      const uid = this.info_list.uid;
      this.$router.push({ path: "/profile-builder", query: { uid } });
    },
    editPostHandler(id) {
      if (id) {
        this.$router.push(`/builder-create-post/${id}`);
      }
    },
    del_post(id) {
      this.$swal
        .fire({
          title: "پست حذف گردد؟",
          text: "پس از این عملیات پست برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              this.helperPost("del-post", { post_id: id })
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    this.$route.push("/");
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {});
            }
          }
        });
    },

    // load_postInfo(postId) {
    //   let self = this;
    //   this.LoadingSkeleton = true;
    //   this.fillter.m_id = postId;
    //   self.helperPost("public-post-list", this.fillter).then((r) => {
    //     self.post_datail = r.data.data.list[0];
    //     this.LoadingSkeleton = false;
    //   });
    // },

    postCommentLoadHandler(param) {
      const postId = this.$route.params.id;
      let self = this;
      this.commentsLoadeMore = true;
      this.commentsLoademoreLoading = true;
      this.page += 1;
      if (param == "first") {
        this.commentsLoading = true;
        this.postCommentsList = [];
        this.Commentpage = 1;
      }

      this.helperGet(
        "get-comment",
        "related_to=post" +
          "&related_id=" +
          postId +
          "&page=" +
          this.Commentpage
      ).then((res) => {
        if (res.data.result == 1) {
          this.total = res.data.data.total;
          // اضافه کردن کامنت‌های جدید به انتهای لیست
          const newComments = [...res.data.data.list].reverse(); // معکوس کردن ترتیب کامنت‌ها
          self.postCommentsList = self.postCommentsList.concat(newComments);

          if (res.data.data.total_page == self.Commentpage) {
            this.commentsLoadeMore = false;
          }
          self.postComment_btn_replay_loading = [];
          self.postCommentsList.forEach(function (v) {
            self.postComment_btn_replay_loading[v.id] = false;
          });
        }

        this.commentsLoading = false;
        this.commentsLoademoreLoading = false;
      });
    },
    postCommentsSaveHandler(parent_id = 0, from) {
      if (!this.$store.state.auth.loggedIn) {
        toast("برای ثبت نظر وارد حساب کاربری خود شوید", {
          type: "error",
        });
        return;
      }
      if (
        this.post_datail &&
        this.post_datail.user_id &&
        this.$store.state.auth.loggedIn &&
        this.parent_id == 0
      ) {
        if (this.post_datail.user_id == this.$store.state.auth.uid) {
          this.newComment = "";
          toast("امکان ثبت نظر برای آگهی‌های متعلق به خودتان وجود ندارد.", {
            type: "error",
          });
          return;
        }
      }
      let self = this;
      const formData = new FormData();

      formData.append("related_id", this.post_datail?.id);
      formData.append("related_to", "post");

      if (this.$store.state.auth.loggedIn)
        formData.append("author_id", this.$store.state.auth.uid);

      // تعیین parent_id برای ریپلای
      const actualParentId = from === "mob" ? this.postParent_id : parent_id;

      if (actualParentId !== 0) {
        formData.append("parent_id", actualParentId);
        formData.append(
          "newComment",
          from === "mob"
            ? this.postNewComment
            : this.post_comment_replay[actualParentId]
        );
        self.postComment_btn_replay_loading[actualParentId] = true;
      } else {
        formData.append("newComment", this.postNewComment);
        self.post_comment_btn_loading = true;
      }

      self.helperPost("save-comment", formData).then((r) => {
        if (r.data.result == "success") {
          // Create new comment object
          // const newComment = {
          //   id: r.data.id || Date.now(),
          //   name: self.$store.state.auth.name || "کاربر",
          //   avatar: self.$store.state.auth.avatar || "",
          //   description:
          //     actualParentId !== 0
          //       ? from === "mob"
          //         ? this.postNewComment
          //         : this.post_comment_replay[actualParentId]
          //       : this.postNewComment,
          //   date: new Date().toLocaleDateString("fa-IR"),
          //   replay: [],
          // };

          if (actualParentId !== 0) {
            // Add reply to parent comment
            // const parentComment = self.postCommentsList.find(
            //   (comment) => comment.id === actualParentId
            // );
            // if (parentComment) {
            //   parentComment.replay.push(newComment);
            // }
            if (from === "mob") {
              self.postNewComment = "";
            } else {
              self.post_comment_replay[actualParentId] = "";
            }
          } else {
            // Add new comment to end of list
            // self.postCommentsList.push(newComment);
            self.postNewComment = "";
          }

          self.postreplyCommentCloseHandler();
          // self.total += 1;

          toast('نظر شما با موفقیت ثبت شد و پس از تأیید مدیریت نمایش داده خواهد شد.', {
            type:'success'
          })
          self.postParent_id = 0;
        } else {
          toast(r.data.msg, {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
        self.postComment_btn_replay_loading[actualParentId] = false;
        self.post_comment_btn_loading = false;
      });
    },
    postreplyCommentCloseHandler() {
      this.postreplyComment = -1;
    },
    postreplyCommentHandler(index) {
      this.postreplyComment = index;
    },
    post_replay_focuse(parent_id = 0) {
      this.postParent_id = parent_id;
      document.getElementById("newComment_mob").focus();
    },
    async shareContent(pid) {
      const routeUId = this.$route.params.userId;
      const routeId = this.$store.state.auth.uid;
      if (this.$store.state.device == "Desktop") {
        const textToCopy = `${window.origin}/builder-post-details/${routeUId}/${pid}`;
        const shareUrl = document.createElement("textarea");
        shareUrl.value = textToCopy;
        document.body.appendChild(shareUrl);

        shareUrl.select();
        document.execCommand("copy");
        document.body.removeChild(shareUrl);

        toast("متن اشتراک گذاری کپی شد.", {
          type: "success",
          dangerouslyHTMLString: true,
        });
      } else {
        try {
          await Share.share({
            title: this.title,
            text: this.text,
            url: `shomalamlak.ir/builder-details/${routeUId}/${routeId}`,
            dialogTitle: "شمال املاک",
          });
        } catch (error) {
          console.error("خطا در اشتراک‌گذاری:", error);
        }
      }
    },
    follow(target_id) {
      var user_id = 0;
      if (this.$store.state.auth.loggedIn) {
        this.loadingFollow = true;
        if (target_id) {
          user_id = this.$store.state.auth.uid;
          this.helperPost("follow", {
            uid: user_id,
            target_id: target_id,
          }).then((r) => {
            this.info_list.is_follow = r.data.result;
            this.loadingFollow = false;
            this.user_info_func();
          });
        }
      } else {
        this.ShowLoginBoxes = true;
        this.$store.state.login_modal = true;
      }
    },
    replay_blur() {
      this.postParent_id = 0;
      this.postNewComment = "";
      if (document.getElementById("newComment_mob")) {
        document.getElementById("newComment_mob").blur();
      }
    },
    save_like(post_id, index) {
      var user_id = 0;
      if (!this.$store.state.auth.loggedIn) {
        toast("برای لایک کردن آگهی وارد حساب کاربری خود شوید.", {
          type: "error",
        });
        return;
      }
      if (
        this.post_datail &&
        this.post_datail.user_id &&
        this.$store.state.auth.loggedIn
      ) {
        if (this.post_datail.user_id == this.$store.state.auth.uid) {
          toast("امکان لایک کردن آگهی‌های متعلق به خودتان وجود ندارد.", {
            type: "error",
          });
          return;
        }
      }
      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
        this.helperGet(
          "save-like",
          "post_id=" + post_id + "&user_id=" + user_id
        ).then((r) => {
          this.completeInfos.posts.list[index].is_like = r.data.result;
          if (r.data.result == 1)
            this.completeInfos.posts.list[index].likes -= 1;

          if (r.data.result == 2)
            this.completeInfos.posts.list[index].likes += 1;
        });
      } else {
        this.ShowLoginBoxes = true;
      }
    },
  },
  mounted() {
    const postID = this.$route.params.id;
    if (postID) {
      // this.load_postInfo(postID);
      this.user_info_func("first");
      this.postCommentLoadHandler("first");
    }
  },
};
</script>

<style scoped lang="scss">
.builderPost {
  width: 100%;
  padding-top: 124px;
  padding-bottom: 92px;
  background: #f9fafb;
  .profileBuilderMain {
    width: 100%;
    padding: 24px 0 54px;

    .mainContainer {
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .containerList {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;

        .listThumb {
          width: 100%;
          aspect-ratio: 1;
          overflow: hidden;
          cursor: pointer;
          position: relative;

          &:hover {
            .thumbContent {
              opacity: 1;
            }
          }

          .thumbPic {
            width: 100%;
            height: 100%;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .thumbContent {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row-reverse;
            gap: 16px;
            background: rgba(0, 0, 0, 0.2);
            transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
            opacity: 0;

            .contentGroup {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: row-reverse;
              gap: 4px;
              color: #fff;

              .groupIcon {
                width: 24px;
                height: 24px;
                color: #fff;

                svg {
                  width: 24px;
                  height: 24px;
                }
              }

              .groupThumb {
                font-size: 0.9rem;
                font-family: "iranyekanB", sans-serif;
              }
            }
          }
        }
      }
    }
  }
}

.changePostBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  cursor: pointer;
  border-radius: 50%;
  color: #000;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
  transition: all 0.1s;

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  svg {
    width: 28px;
    height: 28px;
  }

  &.PrevBtn {
    right: -8%;
  }

  &.NextBtn {
    left: -8%;
  }
}

.detailsContainer {
  position: relative;
  width: 90%;
  height: 84vh;
  max-width: 56rem;
  margin-right: auto;
  margin-left: auto;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);

  .containerList {
    width: 100%;
    height: 100%;

    .listThumb {
      width: 100%;
      height: 100%;
      display: flex;

      .thumbPic {
        width: 60%;
        height: 100%;
        flex-shrink: 0;
        background: #fff;
        border-bottom-right-radius: 8px !important;
        border-top-right-radius: 8px !important;
        overflow: hidden;

        :deep(.swiper) {
          height: 100% !important;

          .swiper-button-next,
          .swiper-button-prev {
            width: 36px;
            height: 36px;
            background: rgba(0, 0, 0, 0.4);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            color: #fff !important;

            &::after {
              font-size: 20px !important;
              font-weight: 700 !important;
              position: absolute !important;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .thumbContent {
        position: relative;
        width: 40%;
        height: 100%;
        overflow: hidden;
        padding-top: 74px;

        .contentHeader {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          z-index: 99;
          background: #fff;
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-top-left-radius: 8px !important;
          border-bottom: 1px solid rgb(229 231 235);

          .headerContent {
            display: flex;
            align-items: center;
            gap: 12px;
            cursor: pointer;

            .contentPic {
              width: 42px;
              height: 42px;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: cover;
              }
            }

            .contentInfo {
              font-family: "iranyekanB", sans-serif;
              font-size: 1rem;
              color: #000;
            }
          }

          .headerOptions {
            display: flex;
            align-items: center;
            gap: 8px;
            .optionFollow {
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.85rem;
              color: #fff;
              background: #0096c7;
              border-radius: 9999px;
              padding: 0 16px;
            }
            .optionUnFollow {
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.85rem;
              color: #0096c7;
              border: 2px solid #0096c7;
              background: #fff;
              border-radius: 9999px;
              padding: 0 16px;
            }

            .optionEditBtn {
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              font-size: 0.925rem;
              color: #fff;
              width: 32px;
              height: 32px;
              border-radius: 6px;
              background: #0096c7;
            }

            .optionDelete {
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              font-size: 0.925rem;
              color: #fff;
              width: 32px;
              height: 32px;
              border-radius: 6px;
              background: #f00;
            }
          }
        }

        .contentMain {
          width: 100%;
          height: calc(100% - 56.8px);
          overflow-x: hidden;
          overflow-y: auto;
          padding: 16px;

          .mianHeader {
            padding-bottom: 16px;
            border-bottom: 1px solid rgb(243 244 246);

            .headerTitle {
              font-family: "iranyekanB", sans-serif;
              font-size: 1rem;
              color: #000;
            }

            .headerContent {
              font-size: 0.9rem;
              text-align: justify;
              line-height: 28px;
              color: #000;
            }
          }

          .mainOptions {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 12px 0;

            .optionsList {
              display: flex;
              align-items: flex-start;

              .optionThumb {
                width: 40px;
                display: flex;
                align-items: center;
                justify-content: start;
                flex-direction: column;
                color: #000;
                gap: 8px;
                cursor: pointer;

                &.liked {
                  color: #f00;

                  .thumbNum {
                    color: #000;
                  }
                }

                svg {
                  width: 28px;
                  height: 28px;
                  flex-shrink: 0;
                }

                .thumbNum {
                  font-size: 0.95rem;
                  line-height: 1.25rem;
                }
              }
            }
          }

          .mainList {
            width: 100%;
            padding-top: 12px;

            .listThumb {
              display: block;
              .listThumbWrapper {
                display: flex;
                align-items: flex-start;
                gap: 12px;
                margin-bottom: 16px;

                .thumbPic {
                  width: 42px;
                  height: 42px;
                  flex-shrink: 0 !important;

                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                  }
                }

                .thumbContent {
                  flex-grow: 1 !important;
                  padding: 0 !important;
                  .contentDesc {
                    font-size: 0.875rem;
                    color: rgb(55 65 81);
                    line-height: 24px;

                    .userTitle {
                      font-family: "iranyekanB", sans-serif;
                      margin-left: 2px;
                      color: #000;
                    }
                  }

                  .contentDetails {
                    margin-top: 4px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    color: rgb(107 114 128);
                    font-size: 0.75rem;

                    .detailsReply {
                      cursor: pointer;
                      transition: all 0.2s;

                      &:hover {
                        color: #0096c7;
                        transform: scale(1.05);
                      }
                    }
                  }
                }
              }

              .thumbReplyList {
                padding-right: 42px;

                .listThumb {
                  .listThumbWrapper {
                    .thumbPic {
                      width: 32px;
                      height: 32px;
                    }

                    .thumbContent {
                      .contentDesc {
                        font-size: 0.75rem;
                      }
                      .contentDetails {
                        font-size: 0.675rem;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .contentFooter {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          background: #fff;
          padding: 8px 16px;
          border-bottom-left-radius: 8px !important;
          border-top: 1px solid rgb(229 231 235);

          .footerFooter {
            .footerGroup {
              position: relative;
              display: flex;
              align-items: center;
              gap: 6px;
              .groupButton {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                flex-shrink: 0;
                cursor: pointer;

                svg {
                  width: 24px;
                  height: 24px;
                  fill: #0096c7;
                }
              }

              .groupInput {
                flex-grow: 1;
                padding: 12px;
                padding-right: 0;
                font-size: 0.9rem;
                background: transparent;
              }

              .cancleReply {
                flex-shrink: 0;
                padding: 4px 8px;
                background: #c2e1ea;
                color: #0096c7;
                border-radius: 9999px;
                cursor: pointer;
                font-size: 0.75rem;
              }
            }
          }
        }
      }
    }
  }
}

.no-result {
  text-align: center;
  margin-top: 32px;
}

@media (max-width: 700px) {
  .profileBuilder {
    .profileBuilderMain {
      padding-bottom: 98px;
      .mainContainer {
        .containerList {
          grid-template-columns: repeat(3, 1fr);
          gap: 4px;

          .listThumb {
            .thumbContent {
              display: none;
            }
          }
        }
      }
    }
  }
}

.apartmentsLoadMoreDataButton {
  width: 100%;
  margin: 36px;
}
.apartmentsLoadMoreDataButton .loadButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  text-align: center;
  background: #2dc653;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.9rem;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}

.loader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.fs-14 {
  font-size: 14px;
}
.role-label {
  background: rgb(223, 233, 244);
  margin-top: 6px;
  padding: 10px 36px;
  border-radius: 24px;
  color: rgba(40, 107, 184);
  margin-top: 16px;

  &.comments {
    background: #0096c7;
    color: #fff;
    margin-right: 12px;
    cursor: pointer;

    &.mobile {
      display: none;
    }

    &.desktop {
      display: block;
    }
  }
}

.loginMessage {
  font-size: 0.9rem;
}

@media (max-width: 600px) {
  .role-label {
    &.comments {
      &.mobile {
        display: block;
      }

      &.desktop {
        display: none;
      }
    }
  }
}

.comments-modal {
  height: 80vh;
}

.sendCommentBtn {
  width: 32px;
  height: 32px;
  background: transparent;
  font-size: 20px;
  color: #0096c7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.commentsList {
  width: 96%;
  margin: 0 auto;
  padding: 24px 0;

  .commentInputWrapper {
    display: flex;
    margin-bottom: 24px;

    .inputUserProfile {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #000;
      margin-left: 16px;
    }

    &.newCommentInput {
      padding-bottom: 24px;
      border-bottom: 1px solid #eee;

      .commentInput {
        .addCommentInput {
          input {
            border: 1px solid #ddd;
            padding: 12px 8px;
            border-radius: 6px;
            font-size: 1rem;
            background: transparent;

            &:focus {
              border: 1px solid #0096c7;
            }
          }

          &::after {
            display: none;
          }
        }
      }
    }

    .commentInput {
      flex: 1;

      .addCommentInput {
        position: relative;
        margin-bottom: 8px;
        input {
          display: block;
          width: 100%;
          padding: 2px 0;
          border-bottom: 1px solid #ccc;
          background: transparent;
        }

        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          display: block;
          width: 100%;
          height: 1.5px;
          background: #0096c7;
          transform: scaleX(0);
          transition: all 0.2s;
        }

        &.focus {
          &::after {
            transform: scaleX(1);
          }
        }
      }

      .commentInputBtns {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .commentBtn,
        .cancleBtn {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 76px;
          height: 36px;
          padding: 0 16px;
          font-size: 14px;
          line-height: 36px;
          border-radius: 18px;
          background: #0096c7;
          color: #fff;
          margin-right: 6px;
          cursor: pointer;

          .loader {
            margin: 0 !important;
          }
        }

        .cancleBtn {
          background: #e5f0ff;
          color: #0096c7;
        }

        .commentBtn.disabled {
          pointer-events: none;
          cursor: none;
          opacity: 0.4;
        }
      }
    }
  }

  .commentThumb {
    display: flex;
    margin-bottom: 16px;

    .commentProfile {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #0096c7;
      flex-shrink: 0;
      margin-left: 16px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .commentContent {
      flex: 1;

      .commentHeader {
        display: flex;
        align-items: center;
        gap: 8px;
        .userName {
          font-family: "iranyekanB", sans-serif;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 2px;
        }

        .commentDate {
          font-family: "iranyekan", sans-serif;
          font-size: 12px;
          color: #999;
        }
      }

      .commentText {
        font-family: "iranyekan", sans-serif;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.25rem;
        margin-bottom: 2px;
      }

      .commentBtns {
        display: flex;
        margin-bottom: 4px;

        .commentLikesBtn {
          display: flex;

          .likeBtnWrapper {
            display: flex;

            .likeNum {
              margin-left: 8px;
              margin-right: 2px;
              padding-top: 4px;
              font-size: 14px;
            }
          }

          .likeBtn,
          .disLikeBtn {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            svg.commentBtnIcon {
              font-size: 14px;
              stroke: #0096c7 !important;
              path {
                stroke: #0096c7 !important;
              }
            }

            &:hover {
              background: #e5f0ff;
            }
          }
        }

        .commentReplyBtn {
          margin-right: 8px;
          margin-top: 6px;
          padding: 0 8px;
          font-size: 13px;
          line-height: 24px;
          border-radius: 16px;
          cursor: pointer;
          background: #e5f0ff;
          color: #0096c7;
        }
      }

      .commentInputWrapper {
        display: none;

        &.show {
          display: flex;
        }
        padding-right: 4px;
        margin-bottom: 2px;
        .inputUserProfile {
          width: 24px;
          height: 24px;
        }
      }

      .commentsReplyToggler {
        .commentsReplyToggleBtn {
          padding: 0 16px;
          width: fit-content;
          height: 36px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          border-radius: 16px;
          color: #0096c7;
          cursor: pointer;

          &:hover {
            background: #e5f0ff;
          }
        }
      }

      .commentsReply {
        display: none;

        &.show {
          display: block;
        }
        .commentThumb {
          width: 100%;
          .commentProfile {
            width: 24px;
            height: 24px;
            margin-right: 16px;
            margin-top: 8px;
          }
        }
      }
    }
  }
}

.commentsDestopBody {
  width: 100%;
}

.roleContainer {
  display: flex;
  align-items: center;
}

.dark {
  .ShowCommandBoxesMyBottomSheet {
    .dentMessageToCommentWrapper {
      background: #101a23;

      .commentRatingComp {
        color: #fff;
      }
    }
  }
  .changePostBtn {
    background: #101a23 !important;
    color: #fff !important;
    box-shadow: 0 0 6px rgba(255, 255, 255, 0.25);
  }
  .detailsContainer {
    .containerList {
      background: #101a23 !important;

      .listThumb {
        .thumbPic {
          background: #1e262f !important;
        }
        .thumbContent {
          .contentHeader {
            background: #101a23 !important;
            border-bottom: 1px solid rgb(53, 53, 54) !important;

            .headerContent {
              .contentInfo {
                color: #fff !important;
              }
            }

            .headerOptions {
              .optionUnFollow {
                background: #101a23 !important;
              }
            }
          }

          .contentMain {
            .mianHeader {
              border-bottom: 1px solid rgb(53, 53, 54) !important;
              .headerTitle,
              .headerContent {
                color: #fff !important;
              }
            }

            .mainOptions {
              .optionsList {
                .optionThumb {
                  &:not(.liked) {
                    color: #fff !important;
                  }

                  .thumbNum {
                    color: #fff !important;
                  }
                }
              }
            }
          }

          .contentFooter {
            background: #101a23 !important;
            border-top: 1px solid rgb(53, 53, 54) !important;

            .footerFooter {
              .footerGroup {
                .groupInput {
                  color: #fff !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

.ShowCommandBoxesMyBottomSheet {
  height: 500px;
  overflow-y: hidden;

  .dentMessageToCommentSpace {
    height: 60px;
  }

  .dentMessageToCommentWrapper {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 10px;
    padding-top: 6px;
    border-top: 1px solid #ededed;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
    background: #fff;

    .commentRatingComp {
      display: flex;
      gap: 6px;
      align-items: center;
      margin-bottom: 4;

      span {
        display: inline-block;
        margin-top: 6px;
        font-size: 0.85rem;
      }

      .el-rate {
        .el-rate__item {
          .el-icon {
            svg {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }

  .dentMessageToComment {
    height: 60px;
    display: flex;
    gap: 10px;
    align-items: center;
    .mobileNewCommentInput {
      width: 100%;
      height: 40px;
      width: 100%;
      height: 40px;
      background: #f5f5f5;
      border-radius: 5px;
      input {
        background: transparent;
        height: 100%;
        padding: 0 10px;
        font-size: 1rem;
      }
    }

    .cancleReply {
      position: absolute;
      left: 22px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 13px;
      padding: 6px 8px;
      border: 1px solid #0096c7;
      background: #e5f0ff;
      color: #0096c7;
      border-radius: 24px;
    }
  }

  .AllChildCommentRefSheet {
    margin: auto;
    width: 95%;
    padding: 10px;
    position: relative;
  }

  .ChildCommentRefSheetVg {
    display: flex;
    align-items: center;
    justify-content: space-between;
    svg {
      cursor: pointer;
    }
  }

  .ChildCommentRefSheet {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    height: 50px;

    .TitleChildCommentRefSheetTitle {
      display: flex;
      flex-direction: column;

      .el-rate__item {
        width: 18px !important;
        height: 16px !important;
      }

      .el-icon.el-rate__icon {
        width: 14px !important;
        height: 14px !important;
        margin: 0 !important;
      }
    }
  }

  .ReplayChildCommentRefSheet {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 50px;
    margin-top: 20px;
    .TitleChildCommentRefSheet {
      border-radius: 10px;

      h1 {
        font-size: 0.85rem;
      }

      p {
        font-size: 0.8rem;
        color: #333;
      }
    }

    .ImageChildCommentRefSheet {
      height: 30px;
      width: 30px;
      border-radius: 100%;
      overflow: hidden;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .ImageChildCommentRefSheet {
    height: 34px;
    width: 34px;
    border-radius: 100%;
    overflow: hidden;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .TitleChildCommentRefSheet {
    h1 {
      font-size: 0.9rem;
      font-weight: 500;
      color: rgb(21, 21, 77);
      font-family: "iranyekanB";
    }

    p {
      font-size: 0.75rem;
      color: #555;
      font-family: "iranyekan";
    }
  }
}

.noComments {
  font-size: 1.15rem;
  padding: 68px 0 54px;
  text-align: center;
}

.mobileNocomments {
  padding: 48px 0;
  font-size: 1rem;
  color: #777;
  text-align: center;
}

.followUnfollowBtns {
  margin-top: 16px;

  .followBtn,
  .unfollowBtn {
    width: 312px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    border: 1px solid #0096c7;
    border-radius: 8px;
    cursor: pointer;
  }

  .followBtn {
    background: #0096c7;
    color: #fff;
  }

  .unfollowBtn {
    background: transparent;
    color: #0096c7;
  }
}

@media (max-width: 700px) {
  .followUnfollowBtns {
    .followBtn,
    .unfollowBtn {
      width: 212px;
      height: 38px;
    }
  }
}

.skeleton-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
}

.TopShowToUSerNAme {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
}

.ImageTopShowToUSerNAme {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f0f0f0;
  margin-right: 10px;
}

.titleTopShowToUSerNAme {
  width: 150px;
  height: 30px;
  background: #f0f0f0;
  border-radius: 4px;
}

.skeleton-image {
  width: 100%;
  height: 200px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-bottom: 15px;
}

.skeleton-text {
  width: 100%;
  height: 15px;
  background: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 10px;
}

.skeleton-text.short {
  width: 60%;
}

.postCommentloader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #0096c7;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.noResultThumb {
  padding: 42px 0;
  .noResultPic {
    img {
      max-width: 90%;
      height: 280px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .noResult {
    text-align: center;
    font-size: 0.95rem;
  }
}

.map {
  width: 100%;
  height: 100%;
}
</style>
